export var SmartSheetInterface;
(function (SmartSheetInterface) {
    var EViewType;
    (function (EViewType) {
        EViewType[EViewType["GRID"] = 1] = "GRID";
        EViewType[EViewType["KANBAN"] = 2] = "KANBAN";
        EViewType[EViewType["GALLERY"] = 3] = "GALLERY";
        EViewType[EViewType["GANTT"] = 4] = "GANTT";
        EViewType[EViewType["CALENDAR"] = 5] = "CALENDAR";
    })(EViewType = SmartSheetInterface.EViewType || (SmartSheetInterface.EViewType = {}));
})(SmartSheetInterface || (SmartSheetInterface = {}));
//# sourceMappingURL=smart-sheet.js.map